import React, { useState, createContext, useEffect } from 'react'

/**
 * The default is the `[state, setState]` PAIR, not `{}`.
 *
 * Every consumer array-destructures this (`const [context, setContext] = useContext(UserContext)`),
 * and array-destructuring a plain object throws `is not iterable` rather than yielding undefineds —
 * so a component rendered outside the provider crashed on its first line instead of degrading. In
 * the app the provider always wraps (`global/index.js` sits above the navigator); this is what lets
 * a screen be unit-tested without one.
 */
export const UserContext = createContext([{}, () => {}])

export const UserProvider = ({ children }) => {
  const [state, setState] = useState({
    user: null,
    db: null,
    productTags: [], // for ecommerce
    productTiles: [], // for ecommerce
    employeesOnShift: [], 
    savedCarts: [], 
    // ATL-1274 — sales this session saved but could not fiscalize. Lives here, above the
    // navigator, so New Sale's banner survives a walk to Sales History and back. See
    // `utils/unfiscalizedSales.ts`.
    unfiscalizedSales: [],
    unsubscribeSavedCarts: null,
    unsubscribeEmployeesOnShift: null,
    unsubscribeProductTags: null,
  })

  useEffect(() => {
    return () => {
      state.unsubscribeWriteOffs?.()
      state.unsubscribeSupplies?.()
      state.unsubscribeRevisions?.()
      state.unsubscribeProducts?.()
      state.unsubscribeSales?.()
      state.unsubscribeSuppliers?.()
      state.unsubscribeSpendings?.()
      state.unsubscribeCashboxTransactions?.()
      state.unsubscribeEmployeesOnShift?.()
      state.unsubscribeReturns?.()
      state.unsubscribeSavedCarts?.()
      state.unsubscribeConstants?.()
      state.unsubscribeProductTags?.()
      state.unsubscribeTransfers?.()
      state.unsubscribeClientOrders?.()
      state.unsubscribeClients?.()
      state.unsubscribeManufactures?.()
    }
  }, [])

  return (
    <UserContext.Provider value={[ state, setState ]}>
      {children}
    </UserContext.Provider>
  )
}  
